
import PreEntryApi from '../../assets/js/preentry'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
XButton,
Flexbox,
FlexboxItem,
Divider,
XHeader,
Loading
},
data () {
return {
id: '',
code: '',
has_offer: '',
pre_code_new: '',
pre_pass: '',
is_pre: false, // 预览模式
is_check_pass: false, // 验证信息通过
status: '',
data: {
format_date: ['', '', ''],
format_nowdate: ['', '', '']
},
showLoading: true
}
},
created () {
this.id = this.$route.query.id
this.pre_pass = this.$route.query.pre_pass
this.pre_code_new = this.$route.query.pre_code_new

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')


if (!this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}


if (!this.code && !this.pre_pass) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
if (this.pre_pass) {

PreEntryApi.checkPreLogin(
{ id: this.id, code: this.pre_code_new, pre_pass: this.pre_pass },

(data, meta) => {
this.is_pre = true
this.is_check_pass = true
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.pre_code_new },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)

PreEntryApi.getStaffDetail(
{ id: this.id, code: this.pre_code_new, from: 'ehr' },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}

if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}
this.showLoading = false
}
},

err => {
if (err === -2) {
this.$message.error(this.$tsg('详情信息未获取，请刷新当前页面'))
} else {
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
})
} else {

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {
this.is_check_pass = true
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
).then(data => {
if (!this.is_check_pass) {
return false
}
PreEntryApi.getStatusValue(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.has_offer = data.has_offer
}
}
)

PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.data = data
this.status = data.status
if (this.data.start_date) {
this.data.format_date = this.data.start_date.split('-')
}

if (this.data.now_date) {
this.data.format_nowdate = this.data.now_date.split('-')
}

if (!this.data.bce_offer_url) {
this.createOfferPDF()
} else {
this.showLoading = false
}

this.showLoading = false
}
},

err => {
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
})
}
},
methods: {
historyBack () {
if (this.$route.name === 'onboard.preview' && this.$route.query.back === 1) {
this.$router.push({ name: 'onboard.code', query: { id: this.$route.query.id } })
return false
} else if (this.$route.name === 'onboard.code') {
window.close()
return false
} else {
history.go(-1)
}
},
createOfferPDF () {
PreEntryApi.createOfferPDF(
{ id: this.id, code: this.code },

(data, meta) => {
this.showLoading = false
},

err => {
this.showLoading = false
return false
},

err => {
this.showLoading = false
this.$message.error(this.$tsg('系统错误，请联系管理员。'))
return false
},

err => {
this.showLoading = false
return false
}
)
},

downloadOffer () {
window.open(process.env.API_HOST + '/api/v1.0/onboard/download_offer?id=' + this.id + '&code=' + this.code)
},

refuseOffer () {
this.$router.push({ name: 'onboard.school_refuse', query: { id: this.id } })
},

acceptOffer () {
PreEntryApi.confirmOffer(
{ id: this.id, code: this.code },
(data, meta) => {
if (data !== '') {
this.$message.error('接受offer失败。')
return false
}

this.$router.push({ name: 'onboard.school_graduate', query: { id: this.id } })
},
err => {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/white_school_offer_rr.vue